import React from 'react';
import ModalSheet from "../../../../components/atoms/modalSheet";
import Button from "../../../../components/atoms/button";
import { IonItem, IonSelect, IonSelectOption } from "@ionic/react";
import './LandOperationsModal.css';

interface LandOperationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOperationSelect: (operationType: string) => void;
  isAdmin: boolean;
  isOperation: boolean;
}

const LandOperationsModal: React.FC<LandOperationsModalProps> = ({
  isOpen,
  onClose,
  onOperationSelect,
  isAdmin,
  isOperation
}) => {
  const [landOperationsValue, setLandOperationsValue] = React.useState<string>("");

  const handleOperationSelect = () => {
    if (landOperationsValue) {
      onOperationSelect(landOperationsValue);
    }
  };

  return (
    <ModalSheet
      isOpen={isOpen}
      initialBreakpoint={0.4}
      breakpoints={[1, 1, 1, 1]}
      onDidDismiss={onClose}
      close={onClose}
    >
      <div className="w-full h-full pt-4 flex flex-col justify-start items-center">
        <p className="font-bold text-primaryColor100 text-2xl whitespace-nowrap animate__animated animate__bounceInDown">
          اختار نوع العملية
        </p>
        <div className="w-full mt-4 border-solid border-2 rounded border-paragraphColor hover:border-primaryColor100 animate__animated animate__bounceInDown">
          <IonItem>
            <IonSelect
              interface="action-sheet"
              placeholder="يرجى الاختيار"
              onIonChange={(e: any) =>
                setLandOperationsValue(e.target.value)
              }
            >
              {isOperation ? (
                <>
                  <IonSelectOption value="2">
                    اعدادات اللوجو
                  </IonSelectOption>
                </>
              ) : isAdmin ? (
                <>
                  <IonSelectOption value="2">
                    اعدادات اللوجو
                  </IonSelectOption>
                  <IonSelectOption value="3">
                    إضافة أو الغاء القطعة المضيئة
                  </IonSelectOption>
                </>
              ) : null}
            </IonSelect>
          </IonItem>
        </div>
        <div className="w-full mt-4 px-4 grid grid-cols-2 gap-4 animate__animated animate__backInUp">
          <Button
            theme={"primary"}
            text={"موافق"}
            size={"big"}
            onClick={handleOperationSelect}
          />
          <Button
            theme={"danger"}
            text={"إغلاق"}
            size={"big"}
            onClick={onClose}
          />
        </div>
      </div>
    </ModalSheet>
  );
};

export default LandOperationsModal;
